import React from "react";
import { Action as ReduxAction } from "redux";
import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import { env } from "../util/env";
import { Moment } from "moment";
import { ReduxState, ReduxDispatch } from "../ducks/reducers";
import { reducer as formReducer, FormState } from "redux-form";

import { reduxForm, formValueSelector } from "redux-form";

import * as request from "../util/request";
import { getStorage } from "../util/storage";
import { PostalCodeDto } from "../util/DTOs/PostalCodeDto";

const ACTION_CREATOR = actionCreatorFactory("bongari/PostalCodes");

export interface IPostalCodeState {
    postalCode: string;
    postalCityFi: string;
    postalCitySe: string;
}

export interface IPostalCodesState {
    [key: string]: IPostalCodeState;
}

export const loadPostalCodes = ACTION_CREATOR<{}, IPostalCodeState[], string>(
    "LOAD_POSTALCODES"
);

export function autoCompletePostalCity(search: string) {
    return async (
        dispatch: ReduxDispatch
    ): Promise<IPostalCodeState[] | undefined> => {
        try {
            const result = await request.get<PostalCodeDto[]>(
                `${env.APP_API_HOST}/api/postalcodes/?search=` + search
            );

            const postalCodes = result.map((dto: PostalCodeDto) => {
                return {
                    ...dto,
                } as IPostalCodeState;
            });

            dispatch(loadPostalCodes.done(postalCodes));
            return postalCodes;
        } catch (error) {}
        return [];
    };
}

export const PostalCodesReducer = reducerWithInitialState<IPostalCodesState>({})
    .case(loadPostalCodes.done, (state, action) => {
        const loadedPostalCodes = action.payload as IPostalCodeState[];
        return loadedPostalCodes.reduce((acc, ap) => {
            return {
                ...acc,
                [ap.postalCode]: {
                    ...ap,
                },
            };
        }, {});
    })
    .case(loadPostalCodes.failed, (state, action) => {
        return {
            ...state,
            // TODO: Add error message / handling
        };
    });

export default PostalCodesReducer;

export const getPostalCodes = (state: ReduxState): IPostalCodeState[] => {
    const allPostalCodes = Object.keys(state.postalCodes).map((key) => {
        return state.postalCodes[key];
    });

    return allPostalCodes;
};



// WEBPACK FOOTER //
// ./src/ducks/postalcodes.ts